import React from "react";
import clsx from "clsx";

export function NovelSettings({ onClick, children }) {
  return (
    <button
      className="flex flex-column items-center cursor-pointer button-transparent"
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 24 24"
        strokeWidth="2"
        stroke="#fafafa"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
      {children}
    </button>
  );
}

export function BlackBgk({ onClick, selected }) {
  return (
    <button className={clsx("cursor-pointer", selected && "items-layered")}>
      <svg
        className="icon icon-tabler icon-tabler-circle-black"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
        width="36"
        height="36"
        viewBox="0 0 24 24"
        strokeWidth="1"
        stroke="#ccc"
        fill="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <circle cx="12" cy="12" r="9" />
      </svg>
      {selected && <SelectedBgk />}
    </button>
  );
}

export function WhiteBgk({ onClick, selected }) {
  return (
    <button className={clsx("cursor-pointer", selected && "items-layered")}>
      <svg
        className="icon icon-tabler icon-tabler-circle-white cursor-pointer"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
        width="36"
        height="36"
        viewBox="0 0 24 24"
        strokeWidth="1"
        stroke="#ccc"
        fill="#FFFFFF"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <circle cx="12" cy="12" r="9" />
      </svg>
      {selected && <SelectedBgk />}
    </button>
  );
}

export function FontSizeDown({ onClick }) {
  return (
    <div style={{ width: "64px", display: "inline-block" }}>
      <button className="cursor-pointer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-letter-case"
          onClick={onClick}
          width="36"
          height="36"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="#3d2a47"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="17.5" cy="15.5" r="3.5" />
          <path d="M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5" />
          <path d="M3 13h7" />
          <path d="M21 12v7" />
        </svg>
      </button>
    </div>
  );
}

export function FontSizeUp({ onClick }) {
  return (
    <button className="cursor-pointer">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-letter-case-toggle"
        onClick={onClick}
        width="36"
        height="36"
        viewBox="0 0 24 24"
        strokeWidth="2"
        stroke="#3d2a47"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <circle cx="6.5" cy="15.5" r="3.5" />
        <path d="M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5" />
        <path d="M14 13h7" />
        <path d="M10 12v7" />
      </svg>
    </button>
  );
}

export function LineDown({ onClick }) {
  return (
    <div style={{ width: "64px", display: "inline-block" }}>
      <button className="flex items-center cursor-pointer" onClick={onClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-align-left"
          width="36"
          height="36"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="#3d2a47"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <line x1="4" y1="6" x2="20" y2="6" />
          <line x1="4" y1="12" x2="14" y2="12" />
          <line x1="4" y1="18" x2="18" y2="18" />
        </svg>
        <span>–</span>
      </button>
    </div>
  );
}

export function LineUp({ onClick }) {
  return (
    <button className="flex items-center cursor-pointer" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-align-left"
        width="36"
        height="36"
        viewBox="0 0 24 24"
        strokeWidth="2"
        stroke="#3d2a47"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <line x1="4" y1="6" x2="20" y2="6" />
        <line x1="4" y1="12" x2="14" y2="12" />
        <line x1="4" y1="18" x2="18" y2="18" />
      </svg>
      <span>+</span>
    </button>
  );
}

export function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  );
}

function SelectedBgk() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-check"
      width="36"
      height="36"
      viewBox="0 0 20 20"
      strokeWidth="2"
      stroke="#ffc100"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M5 12l5 5l10 -10" />
    </svg>
  );
}
